import * as React from 'react';
import IconBase, { IconBaseProps } from '../components/Icons/IconBase';
const props = {};

const SvgFrontDesk = (allProps: IconBaseProps) => {
  return (
    <IconBase {...allProps}>
      <svg
        width="1em"
        height="1em"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M13.875 10.75C13.875 11.413 14.1384 12.0489 14.6072 12.5178C15.0761 12.9866 15.712 13.25 16.375 13.25C17.038 13.25 17.6739 12.9866 18.1428 12.5178C18.6116 12.0489 18.875 11.413 18.875 10.75C18.875 10.087 18.6116 9.45107 18.1428 8.98223C17.6739 8.51339 17.038 8.25 16.375 8.25C15.712 8.25 15.0761 8.51339 14.6072 8.98223C14.1384 9.45107 13.875 10.087 13.875 10.75Z"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M21.375 18.25C21.375 17.2554 20.9799 16.3016 20.2766 15.5983C19.5734 14.8951 18.6196 14.5 17.625 14.5H15.125C14.1304 14.5 13.1766 14.8951 12.4733 15.5983C11.7701 16.3016 11.375 17.2554 11.375 18.25"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M2.625 20.75H21.375"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14.3242 9.32L12.5742 7.03667C13.6665 6.20079 15.004 5.74856 16.3794 5.75006C17.7548 5.75157 19.0913 6.20673 20.1817 7.045L18.4301 9.32667"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9.5 5.75H7.625V3.875C7.625 3.70924 7.55915 3.55027 7.44194 3.43306C7.32473 3.31585 7.16576 3.25 7 3.25H5.75C5.58424 3.25 5.42527 3.31585 5.30806 3.43306C5.19085 3.55027 5.125 3.70924 5.125 3.875V5.75H3.25C3.08424 5.75 2.92527 5.81585 2.80806 5.93306C2.69085 6.05027 2.625 6.20924 2.625 6.375V7.625C2.625 7.79076 2.69085 7.94973 2.80806 8.06694C2.92527 8.18415 3.08424 8.25 3.25 8.25H5.125V10.125C5.125 10.2908 5.19085 10.4497 5.30806 10.5669C5.42527 10.6842 5.58424 10.75 5.75 10.75H7C7.16576 10.75 7.32473 10.6842 7.44194 10.5669C7.55915 10.4497 7.625 10.2908 7.625 10.125V8.25H9.5C9.66576 8.25 9.82473 8.18415 9.94194 8.06694C10.0592 7.94973 10.125 7.79076 10.125 7.625V6.375C10.125 6.20924 10.0592 6.05027 9.94194 5.93306C9.82473 5.81585 9.66576 5.75 9.5 5.75Z"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </IconBase>
  );
};

SvgFrontDesk.displayName = 'SvgFrontDesk';
export default SvgFrontDesk;
